import React from 'react';
import Slider from 'react-slick';
import { courseAds } from '../data/courseAds';
import '../styles/AdvertisementCarousel.css';

const AdvertisementCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: false,
  };

  const handleCourseClick = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <aside className="course-ads">
      <div className="course-ads-header">
        <h3 className="course-ads-title">Udemy Courses</h3>
        <p className="course-ads-subtitle">By Shelendra Kumar</p>
      </div>

      <div className="carousel-container">
        <Slider {...settings}>
          {courseAds.map((course) => (
            <div key={course.url} className="course-slide-wrap">
              <button
                type="button"
                className="course-slide"
                onClick={() => handleCourseClick(course.url)}
              >
                <img
                  src={course.thumbnail}
                  alt={course.title}
                  className="course-thumbnail"
                />
                <div className="course-slide-info">
                  <h4>{course.title}</h4>
                  <p className="course-slide-subtitle">{course.subtitle}</p>
                  <div className="course-slide-meta">
                    <div className="course-slide-rating-row">
                      <span className="course-rating">★ {course.rating}</span>
                      <span className="course-highest-rated-badge">Highest Rated</span>
                    </div>
                    {course.udemyBusinessFree && (
                      <span className="course-free-badge">FREE on Udemy Business</span>
                    )}
                  </div>
                  <span className="course-cta">View on Udemy →</span>
                </div>
              </button>
            </div>
          ))}
        </Slider>
      </div>
    </aside>
  );
};

export default AdvertisementCarousel;
